import Kpi from 'types/Kpi';

export const LOW_MONTH_SENTINEL: Month = { month: 1, year: 2999 };
export const HIGH_MONTH_SENTINEL: Month = { month: 1, year: 1999 };

export interface Month {
    month: number;
    year: number;
}

export interface DirtyCell {
    kpiId: number;
    month: number | null;
    year: number | null;
}

export interface QueueItem {
    id: string;
    kpiId: number;
    data: Kpi;
    status: 'waiting' | 'running' | 'success' | 'failed';
}

export type SavingStatus = 'pending' | 'success' | 'failed';